import { GelTheme } from 'components/GelTheme';
import styled from 'styled-components';
import { NavigationButton, NavigationButtonProps } from './NavigationButton';

export interface NavigationButtonConfig extends NavigationButtonProps {
  id?: string;
  isVisible?: boolean;
}

export interface NavigationButtonsProps {
  leftButtonConfig?: NavigationButtonConfig;
  rightButtonConfig?: NavigationButtonConfig;
  backButtonConfig?: NavigationButtonConfig;
}

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${GelTheme.spacing(2.5)};

  // This only applies to the "back" button since the other two buttons are inside of a div
  & > button {
    align-self: flex-start;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${GelTheme.spacing(1)};

  @media screen and (max-width: ${GelTheme.breakpoint('sm')}) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

export const NavigationButtons = ({
  leftButtonConfig,
  rightButtonConfig,
  backButtonConfig,
}: NavigationButtonsProps) => {
  const leftButtonConfigValue: NavigationButtonConfig = {
    id: 'btnSave',
    isVisible: true,
    disabled: false,
    label: 'Save',
    type: 'button',
    ...(leftButtonConfig ?? {}),
  };

  const rightButtonConfigValue: NavigationButtonConfig = {
    id: 'btnCancel',
    isVisible: true,
    disabled: false,
    label: 'Cancel',
    theme: 'secondary',
    type: 'button',
    ...(rightButtonConfig ?? {}),
  };

  const backButtonConfigValue: NavigationButtonConfig = {
    id: 'btnBack',
    isVisible: false,
    disabled: false,
    label: 'Back',
    type: 'button',
    variant: 'back',
    ...(backButtonConfig ?? {}),
  };

  const showButtons = leftButtonConfigValue.isVisible || rightButtonConfigValue.isVisible;

  return (
    <OuterContainer>
      {showButtons && (
        <ButtonContainer>
          {leftButtonConfigValue.isVisible && <NavigationButton {...leftButtonConfigValue} />}
          {rightButtonConfigValue.isVisible && <NavigationButton {...rightButtonConfigValue} />}
        </ButtonContainer>
      )}

      {backButtonConfigValue.isVisible && <NavigationButton {...backButtonConfigValue} />}
    </OuterContainer>
  );
};
